import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../store/app.states';
import { ComponentBase } from '../../views/component-base';
import { OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { loginRequest } from 'src/app/auth-config';

@Component({
  selector: 'app-elevated-access',
  templateUrl: './elevated-access.component.html',
  styleUrls: ['./elevated-access.component.scss'],
})
export class ElevatedAccessComponent
  extends ComponentBase
  implements OnInit, OnDestroy
{
  constructor(
    public store: Store<AppState>,
    public router: Router,
    public authService: MsalService
  ) {
    super();
  }

  async ngOnInit() {
    super.ngOnInitBase();
    sessionStorage.setItem('login-type', 'Elevated');

    if (window.self !== window.top) {
      await this.authService.instance
        .loginPopup(loginRequest)
        .then((response) => {
          this.authService.instance.setActiveAccount(response.account);
        })
        .catch((_) => {
          this.authService.instance.logout();
        });
    } else {
      this.router.navigate(['/dashboard']);
    }
  }

  ngOnDestroy() {
    super.ngOnDestroyBase();
  }
}
